import React, { ReactNode, useRef } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { QUERY_CACHE_TIME_MS, QUERY_STALE_TIME_MS } from '../constants/cache';

const createQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: QUERY_STALE_TIME_MS,
      cacheTime: QUERY_CACHE_TIME_MS,
    },
  },
});

type Props = {
  children: ReactNode;
};

export const DmbQueryClientProvider = ({ children }: Props) => {
  const queryClientRef = useRef<QueryClient | null>(null);
  if (!queryClientRef.current) {
    queryClientRef.current = createQueryClient();
  }

  return (
    <QueryClientProvider client={queryClientRef.current}>
      {children}
    </QueryClientProvider>
  );
};
